export const DRESSING_SALAD = [
  {
    id: 1,
    name: 'Ranch Dressing',
    price3oz: 0.75
  },
  {
    id: 2,
    name: "Blue Cheese Dressing",
    price3oz: 0.75,
  },
  {
    id: 3,
    name: "Italian Dressing",
    price3oz: 0.75,
  },
  {
    id: 4,
    name: "Caesar Dressing",
    price3oz: 0.75,
  },  
];